const normalizeValue = (value) => {
    if (value === null || value === undefined || value === "") return null;

    if (Array.isArray(value)) {
        value = value.length ? value[0] : null;
    }

    const num = Number(value);
    return Number.isNaN(num) ? null : num;
};

const format = (value, decimals = null) => {
    if (value == null) return "N/A";
    return decimals !== null ? value.toFixed(decimals) : value;
};

const calculateVolume = (dx, dy, dz, decimals = null) => {
    if (dx == null || dy == null || dz == null) return null;
    const volume = dx * dy * dz;
    return decimals !== null ? Number(volume.toFixed(decimals)) : volume;
};

const DisplayDimensions = ({ item, eleType = "span", showType = ["mm", "inch"] }) => {
    if (!item?.stagingPartsDataId) return null;
    const bbox = item.stagingPartsDataId;

    // Normalize values
    const bboxDx_mm = normalizeValue(bbox.bboxDx_mm);
    const bboxDy_mm = normalizeValue(bbox.bboxDy_mm);
    const bboxDz_mm = normalizeValue(bbox.bboxDz_mm);

    const bboxDx_in = normalizeValue(bbox.bboxDx_in);
    const bboxDy_in = normalizeValue(bbox.bboxDy_in);
    const bboxDz_in = normalizeValue(bbox.bboxDz_in);

    const totalVolume_mm3 = normalizeValue(bbox.totalVolume_mm3);

    // Determine what should be shown
    const allowMM = showType?.includes("mm");
    const allowIN = showType?.includes("inch");

    const isValidDim = (x, y, z) => x != null && y != null && z != null && x !== 0 && y !== 0 && z !== 0;

    const hasMM = allowMM && (isValidDim(bboxDx_mm, bboxDy_mm, bboxDz_mm) || totalVolume_mm3 != null);
    const hasIN = allowIN && (isValidDim(bboxDx_in, bboxDy_in, bboxDz_in) || totalVolume_mm3 != null);

    // Use totalVolume_mm3 if available, otherwise calculate
    const volumeMm = totalVolume_mm3 !== null
        ? Number(totalVolume_mm3.toFixed(2))
        : (isValidDim(bboxDx_mm, bboxDy_mm, bboxDz_mm) ? calculateVolume(bboxDx_mm, bboxDy_mm, bboxDz_mm, 2) : null);

    const volumeIn = totalVolume_mm3 !== null
        ? Number((totalVolume_mm3 / 16387.064).toFixed(2))
        : (isValidDim(bboxDx_in, bboxDy_in, bboxDz_in) ? calculateVolume(bboxDx_in, bboxDy_in, bboxDz_in, 2) : null);

    const Content = (
        <>
            {/* Dimensions */}
            {hasMM && (
                <>
                    {format(bboxDx_mm)} x {format(bboxDy_mm)} x {format(bboxDz_mm)} (mm)
                </>
            )}

            {hasMM && hasIN && " / "}

            {hasIN && (
                <>
                    {format(bboxDx_in, 2)} x {format(bboxDy_in, 2)} x {format(bboxDz_in, 2)} (inch)
                </>
            )}

            {/* Volume */}
            {(volumeMm !== null || volumeIn !== null) && (
                <span className="block mt-1">
                    Volume:
                    {volumeMm !== null && <> {format(volumeMm, 2)} mm³</>}
                    {volumeMm !== null && volumeIn !== null && " / "}
                    {volumeIn !== null && <> {format(volumeIn, 2)} in³</>}
                </span>
            )}
        </>
    );

    if (eleType === "li") {
        return <li className="!text-[12px] text-gray-800">{Content}</li>;
    }

    return <span className="!text-[12px] text-gray-800">{Content}</span>;
};

export default DisplayDimensions;
